import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OrderFilters } from '../orders/models/order';
import { OrderService } from '../orders/services/order.service';
import { OrderSharedService } from '../orders/services/order-shared.service';
import { ToastService } from '../shared/services/toast.service';
import { jwtPayload } from '../shared/commons/token-payload';
import { ReportsService } from '../reports/services/reports.service';
declare var $: any;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  animations: [],
})
export class NavbarComponent implements OnInit {
  preference = new Preference();
  isDivVisible = false;
  urlParam: number;
  urlSegment: string;

  roles: string;
  fullName: string;
  proId: number;

  catalogs: { route: string; descr: string }[] = [
    { route: 'catalogs/shippers', descr: 'Shipper' },
    { route: 'catalogs/consignees', descr: 'Consignee' },
    { route: 'catalogs/drivers', descr: 'Drivers' },
    { route: 'catalogs/driver-document-types', descr: 'Driver Document Types' },
    { route: 'catalogs/storage-locations', descr: 'Storage Locations' },
    { route: 'catalogs/ramps', descr: 'Ramps' },
    { route: 'catalogs/accesorials', descr: 'Accessorial' },
    { route: 'catalogs/box-sizes', descr: 'Box Size' },
    { route: 'catalogs/rates', descr: 'Trasportation Type' },
    { route: 'catalogs/cities', descr: 'Cities' },
    { route: 'catalogs/city-rates', descr: 'City Rates' },
    { route: 'catalogs/lease-to', descr: 'Lease To' },
  ];

  constructor(
    private _router: Router,
    private _orderService: OrderService,
    private _shared: OrderSharedService,
    private _toast: ToastService,
    private _reportsService: ReportsService,
  ) {
    const payload = jwtPayload();
    this.roles = payload?.roles || payload?.role || '';
    this.fullName = payload?.name || '';
  }

  ngOnInit(): void {
  }

  toggleDiv() {
    this.isDivVisible = !this.isDivVisible;
  }

  LogOut() {
    localStorage.removeItem('tristateToken');
    this._router.navigateByUrl('auth/login');
  }

  SearchNewOrder() {
    var req = new OrderFilters();
    req.ProId = this.proId;

    this._orderService.FilterOrders(req).subscribe({
      next: (res) => {
        if (res.body.length >= 1) {
          this._router.navigateByUrl('/orders/order-info');
          this._shared.SetOrderToStorage(res.body[0]);
          this.proId = null;

          if (this._router.url.includes('/orders/order-info'))
            this._shared.reloadEvent.emit();
        } else {
          this._toast.ShowToast('error', 'Order not found!');
        }
      },
      error: () => {
        this._toast.ShowToast('error', 'Order not found!');
      },
    });
  }

  OpenPreferencesModal() {
    $('#preferenceConfig').modal('show');
    this.GetAppPreferences();
  }

  GetAppPreferences() {
    this._orderService.GetAppPreferences().subscribe({
      next: (res) => {
        this.preference = res.body;
      },
    });
  }

  UpdatePreferences() {
    this._orderService.UpdatePreferences(this.preference).subscribe({
      next: () => {
        this._toast.ShowToast('success');
      },
    });
  }

}

export class Preference {
  seqNumber: number;
  chargeFuelFlag: number;
  fuelPctOfDray: number;
  driverFuelPercentOfDray: number;
  driverDrayPercent: number;
  accesorialsStorageId: number;
  marginStoragePerc: number;
  chargeForRampTermination: number;
  driverCommissionPerc: number;
  storageRatePerDayForClient: number;

  constructor() {
    this.chargeFuelFlag = null;
    this.fuelPctOfDray = null;
    this.driverFuelPercentOfDray = null;
    this.driverDrayPercent = null;
    this.accesorialsStorageId = null;
    this.marginStoragePerc = null;
    this.chargeForRampTermination = null;
    this.driverCommissionPerc = null;
    this.storageRatePerDayForClient = null;
  }
}
